import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-student-fine-details",
	templateUrl: "./student-fine-details.component.html",
	styleUrls: ["./student-fine-details.component.css"],
})
export class StudentFineDetailsComponent implements OnInit {
	constructor(private dialogConfig: DynamicDialogConfig, private ref: DynamicDialogRef) {}

	ngOnInit(): void {
		this.user = this.dialogConfig.data.user;
		this.SelectedPerson = this.dialogConfig.data.SelectedPerson;
		this.CurrentBalance = this.dialogConfig.data.CurrentBalance;
		this.SelectedFine = this.dialogConfig.data.SelectedFine;

		this.StudentID = this.SelectedPerson.DesignatorID;
		this.StudentName = this.SelectedPerson.PersonName;
		this.CurrentBalanceDesc = "$" + this.CurrentBalance;

		this.popup_WidthInt = window.innerWidth - 100;
		this.popup_Width = this.popup_WidthInt.toString() + "px;";

		this.UpdateData();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////
	popup_WidthInt: any = 0;
	popup_Width: any = "";

	user: any;
	SelectedPerson: any;
	CurrentBalance: any;
	SelectedFine: any;

	StudentID: any = "";
	StudentName: any = "";
	CurrentBalanceDesc: any = "";
	FineDT: any = "";
	TransactionDesc: any = "";
	AdminName: any = "";
	OriginalAmount: any = "";
	ItemBalance: any = "";
	Comments: any = "";

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////
	UpdateData() {
		this.FineDT = this.SelectedFine.FineDateDesc;
		this.TransactionDesc = this.SelectedFine.FineTypeDesc;
		this.AdminName = this.SelectedFine.AdminName;
		this.OriginalAmount = this.SelectedFine.AmountDesc;
		this.ItemBalance = this.SelectedFine.BalanceDesc;
		this.Comments = this.SelectedFine.FineComment;

		// console.log(this.SelectedFine);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////
	onClose() {
		this.ref.close(0);
	}
	////////////////////////////////////////////
}
